import { useState } from 'react';

import type { Feedback, NewFeedback } from './add_order_feedback.request';
import { useApiClient } from '../../core/libs/api/api-client.provider';
import { HttpResource } from '../../core/libs/http-resource';
import { AppNotify } from '../../features/app-notify/app-notify';
import { addOrderFeedback } from './add_order_feedback.request';

type UseAddOrderFeedbackParams = {
  onFeedbackAdded?: (feedback: Feedback) => void;
};

export const useAddOrderFeedback = ({
  onFeedbackAdded,
}: UseAddOrderFeedbackParams = {}) => {
  const apiClient = useApiClient();

  const [addOrderFeedbackRequest] = useState(
    () =>
      new HttpResource<NewFeedback, Feedback>({
        apiClient,
        httpRequest: addOrderFeedback,
        errorNotify: new AppNotify(),
        onFinish(result) {
          onFeedbackAdded?.(result);
        },
      })
  );

  return {
    loading: addOrderFeedbackRequest.isLoading,
    addFeedback: (feedback: NewFeedback) =>
      addOrderFeedbackRequest.send(feedback),
  };
};
